(function () {
  'use strict';

  function splitValues(value) {
    if (!value) return [];
    return value.split('||').map(function (item) {
      return item.trim();
    }).filter(Boolean);
  }

  function normalise(value) {
    return String(value || '').trim().toLowerCase();
  }

  function sizeMatches(length, preference) {
    if (!preference) return true;
    if (preference === 'essential') return length > 0 && length <= 3;
    if (preference === 'complete') return length >= 4 && length <= 5;
    if (preference === 'extended') return length >= 6;
    return true;
  }

  function smoothScrollTo(element) {
    if (!element) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    element.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function legacyCopyText(value) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      textarea.style.top = '0';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      try {
        var copied = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (copied) resolve();
        else reject(new Error('Copy command was not accepted.'));
      } catch (error) {
        document.body.removeChild(textarea);
        reject(error);
      }
    });
  }

  function copyText(value) {
    if (
      window.isSecureContext &&
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === 'function'
    ) {
      return navigator.clipboard.writeText(value).catch(function () {
        return legacyCopyText(value);
      });
    }

    return legacyCopyText(value);
  }

  function Finder(root) {
    if (!root || root.dataset.finderInitialised === 'true') return;

    this.root = root;
    this.form = root.querySelector('[data-routine-form]');
    this.concern = root.querySelector('[data-routine-concern]');
    this.skinType = root.querySelector('[data-routine-skin-type]');
    this.routineSize = root.querySelector('[data-routine-size]');
    this.activeLevel = root.querySelector('[data-routine-active-level]');
    this.results = root.querySelector('[data-routine-results]');
    this.resultsGrid = root.querySelector('[data-results-grid]');
    this.resultsTitle = root.querySelector('[data-results-title]');
    this.resultsNote = root.querySelector('[data-results-note]');
    this.noResults = root.querySelector('[data-no-results]');
    this.resetButton = root.querySelector('[data-routine-reset]');
    this.routeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-select-route]'));
    this.products = this.readProducts();

    if (!this.form || !this.concern || !this.results || !this.resultsGrid) return;

    root.dataset.finderInitialised = 'true';
    root.classList.add('is-ready');
    this.bindEvents();
    this.restoreFromUrl();
  }

  Finder.prototype.readProducts = function () {
    var templates = Array.prototype.slice.call(this.root.querySelectorAll('template[data-routine-product]'));

    return templates.map(function (template) {
      var titleElement = template.content.querySelector('h4');
      return {
        template: template,
        title: titleElement ? titleElement.textContent.trim() : '',
        concerns: splitValues(template.dataset.concerns),
        primaryConcern: template.dataset.primaryConcern || '',
        specialPaths: splitValues(template.dataset.specialPaths),
        skinTypes: splitValues(template.dataset.skinTypes),
        activeLevel: template.dataset.activeLevel || '',
        routineLength: parseInt(template.dataset.routineLength, 10) || 0,
        priority: parseInt(template.dataset.priority, 10) || 0,
        available: template.dataset.available === 'true'
      };
    });
  };

  Finder.prototype.bindEvents = function () {
    var self = this;

    this.form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!self.concern.value) {
        self.concern.focus();
        return;
      }
      self.findMatches(true);
    });

    this.routeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var routeValue = button.dataset.selectRoute;
        var matchingOption = Array.prototype.some.call(self.concern.options, function (option) {
          return option.value === routeValue;
        });

        if (!matchingOption) return;
        self.concern.value = routeValue;
        smoothScrollTo(self.root.querySelector('#routine-finder-tool'));
        window.setTimeout(function () {
          self.skinType.focus();
        }, 450);
      });
    });

    if (this.resetButton) {
      this.resetButton.addEventListener('click', function () {
        self.form.reset();
        self.results.hidden = true;
        self.resultsGrid.replaceChildren();
        self.noResults.hidden = true;
        self.updateUrl(true);
        self.concern.focus();
      });
    }
  };

  Finder.prototype.restoreFromUrl = function () {
    var parameters = new URLSearchParams(window.location.search);
    var concern = parameters.get('routine_concern');
    var skinType = parameters.get('skin_type');
    var size = parameters.get('routine_size');
    var activeLevel = parameters.get('active_level');

    if (!concern) return;

    var validConcern = Array.prototype.some.call(this.concern.options, function (option) {
      return option.value === concern;
    });

    if (!validConcern) return;

    this.concern.value = concern;
    if (skinType) this.skinType.value = skinType;
    if (size) this.routineSize.value = size;
    if (activeLevel) this.activeLevel.value = activeLevel;
    this.findMatches(false);
  };

  Finder.prototype.findMatches = function (shouldScroll) {
    var selectedRoute = this.concern.value;
    var selectedSkin = this.skinType.value;
    var selectedSize = this.routineSize.value;
    var selectedActive = this.activeLevel.value;
    var routeKey = normalise(selectedRoute);
    var skinKey = normalise(selectedSkin);
    var activeKey = normalise(selectedActive);

    var candidates = this.products.filter(function (product) {
      var productRoutes = product.concerns.concat(product.specialPaths, [product.primaryConcern]).map(normalise);
      return productRoutes.indexOf(routeKey) !== -1;
    });

    var hasExactSkinMatches = Boolean(skinKey) && candidates.some(function (product) {
      return product.skinTypes.map(normalise).indexOf(skinKey) !== -1;
    });

    if (hasExactSkinMatches) {
      candidates = candidates.filter(function (product) {
        return product.skinTypes.map(normalise).indexOf(skinKey) !== -1;
      });
    }

    candidates.forEach(function (product) {
      var skinMatch = !skinKey || product.skinTypes.map(normalise).indexOf(skinKey) !== -1;
      var routineSizeMatch = sizeMatches(product.routineLength, selectedSize);
      var activeMatch = !activeKey || normalise(product.activeLevel) === activeKey;
      product.matchScore = 1000;
      product.matchScore += skinMatch ? 160 : 0;
      product.matchScore += routineSizeMatch ? 65 : 0;
      product.matchScore += activeMatch ? 45 : 0;
      product.matchScore += product.priority;
      product.matchScore += product.available ? 3 : 0;
    });

    candidates.sort(function (a, b) {
      if (b.matchScore !== a.matchScore) return b.matchScore - a.matchScore;
      return a.title.localeCompare(b.title);
    });

    this.renderResults(candidates.slice(0, 2), {
      selectedRoute: selectedRoute,
      selectedSkin: selectedSkin,
      exactSkin: hasExactSkinMatches
    });
    this.updateUrl(false);
    this.trackSelection(candidates.length);

    if (shouldScroll) smoothScrollTo(this.results);
  };

  Finder.prototype.renderResults = function (matches, context) {
    var self = this;
    this.results.hidden = false;
    this.resultsGrid.replaceChildren();
    this.noResults.hidden = matches.length > 0;
    this.resultsTitle.textContent = context.selectedSkin
      ? context.selectedRoute + ' for ' + context.selectedSkin.toLowerCase() + ' skin'
      : context.selectedRoute;

    if (!matches.length) {
      this.resultsNote.textContent = 'No routines currently match this route.';
      return;
    }

    if (context.selectedSkin && !context.exactSkin) {
      this.resultsNote.textContent = 'No exact skin-type match was available, so we are showing the strongest matches for your main need.';
    } else if (matches.length === 1) {
      this.resultsNote.textContent = 'One strong match found from the current curated routines.';
    } else {
      this.resultsNote.textContent = 'The closest match appears first, followed by one useful alternative.';
    }

    matches.forEach(function (product, index) {
      var fragment = product.template.content.cloneNode(true);
      var card = fragment.querySelector('.luxi-routine-finder__match-card');
      var label = fragment.querySelector('[data-match-label]');
      if (card && index === 0) card.classList.add('is-best-match');
      if (label) label.textContent = index === 0 ? 'Best match' : 'Alternative';
      if (card) self.prepareShare(card);
      self.resultsGrid.appendChild(fragment);
    });
  };

  Finder.prototype.prepareShare = function (card) {
    var self = this;
    var button = card.querySelector('[data-routine-share]');

    if (!button || button.dataset.shareInitialised === 'true') return;

    button.dataset.shareInitialised = 'true';
    button.hidden = false;
    button.addEventListener('click', function () {
      self.shareRoutine(button);
    });
  };

  Finder.prototype.buildShareUrl = function (productUrl) {
    var url;

    try {
      url = new URL(productUrl || window.location.href, window.location.origin);
    } catch (error) {
      url = new URL(window.location.href);
    }

    url.searchParams.set('utm_source', 'customer_share');
    url.searchParams.set('utm_medium', 'web_share');
    url.searchParams.set('utm_campaign', 'routine_finder');

    return url.toString();
  };

  Finder.prototype.setShareBusy = function (button, busy) {
    button.disabled = busy;
    if (busy) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  };

  Finder.prototype.showShareStatus = function (button, message) {
    var shareWrap = button.closest('.luxi-routine-finder__share');
    var status = shareWrap ? shareWrap.querySelector('[data-share-status]') : null;

    if (!status) return;

    if (button.luxiShareStatusTimer) {
      window.clearTimeout(button.luxiShareStatusTimer);
    }

    status.textContent = message || '';

    if (message) {
      button.luxiShareStatusTimer = window.setTimeout(function () {
        status.textContent = '';
      }, 4000);
    }
  };

  Finder.prototype.copyRoutine = function (button, fullText, title, shareUrl) {
    var self = this;

    return copyText(fullText).then(function () {
      self.showShareStatus(button, 'Routine link copied.');
      self.trackShare(title, shareUrl, 'copy');
    }).catch(function () {
      window.prompt('Copy this routine link:', shareUrl);
      self.showShareStatus(button, 'Copy the routine link shown above.');
    });
  };

  Finder.prototype.shareRoutine = function (button) {
    var self = this;
    var title = button.dataset.shareTitle || 'Luxiface Korean skincare routine';
    var shareUrl = this.buildShareUrl(button.dataset.shareUrl);
    var shareText = 'I found this Luxiface-curated Korean skincare routine and thought it might interest you:\n' + title;
    var fullText = shareText + '\n' + shareUrl;
    var shareData = {
      title: title + ' | Luxiface',
      text: shareText,
      url: shareUrl
    };

    this.setShareBusy(button, true);
    this.showShareStatus(button, '');

    if (typeof navigator.share === 'function') {
      navigator.share(shareData).then(function () {
        self.showShareStatus(button, 'Share menu opened.');
        self.trackShare(title, shareUrl, 'native');
      }).catch(function (error) {
        if (error && error.name === 'AbortError') return;
        return self.copyRoutine(button, fullText, title, shareUrl);
      }).then(function () {
        self.setShareBusy(button, false);
      }, function () {
        self.setShareBusy(button, false);
      });

      return;
    }

    this.copyRoutine(button, fullText, title, shareUrl).then(function () {
      self.setShareBusy(button, false);
    }, function () {
      self.setShareBusy(button, false);
    });
  };

  Finder.prototype.trackShare = function (title, shareUrl, method) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'luxiface_routine_share',
      routine_title: title,
      routine_url: shareUrl,
      share_method: method,
      routine_concern: this.concern.value || 'Not selected',
      skin_type: this.skinType.value || 'Not sure',
      routine_size: this.routineSize.value || 'Any',
      active_level: this.activeLevel.value || 'Any'
    });
  };

  Finder.prototype.updateUrl = function (clear) {
    if (!window.history || !window.history.replaceState) return;

    var url = new URL(window.location.href);
    var fields = {
      routine_concern: clear ? '' : this.concern.value,
      skin_type: clear ? '' : this.skinType.value,
      routine_size: clear ? '' : this.routineSize.value,
      active_level: clear ? '' : this.activeLevel.value
    };

    Object.keys(fields).forEach(function (key) {
      if (fields[key]) url.searchParams.set(key, fields[key]);
      else url.searchParams.delete(key);
    });

    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  };

  Finder.prototype.trackSelection = function (matchCount) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'luxiface_routine_finder_submit',
      routine_concern: this.concern.value,
      skin_type: this.skinType.value || 'Not sure',
      routine_size: this.routineSize.value || 'Any',
      active_level: this.activeLevel.value || 'Any',
      match_count: matchCount
    });
  };

  function initialise(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-luxiface-routine-finder]')) roots.push(scope);
    if (scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-luxiface-routine-finder]')));
    }
    Array.prototype.forEach.call(roots, function (root) {
      new Finder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialise(document);
    });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
})();
